<template lang="html">
  <div class="fan">
    <div class="shareIcon" v-show="shareFlag">
      <img
        class="close"
        src="//cdn.yxvzb.com/html/shareToFans/close.png"
        @click="shareFlag = false"
      />
      <img
        src="http://cdn.yxvzb.com/html/shareToFans/share.png"
        @click="qrFlag = true"
      />
    </div>
    <div
      class="qrBox"
      @touchmove.prevent
      v-show="qrFlag"
      @click="qrFlag = false"
    >
      <div @click.stop></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shareFlag: true,
      qrFlag: false
    };
  }
};
</script>

<style lang="less" scoped>
.fan {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.shareIcon {
  position: fixed;
  right: 0.2rem;
  bottom: 2.67rem;
  .close {
    border-radius: 50%;
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0;
    right: 0;
  }
  > img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
}
.qrBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  > div {
    width: 8.43rem;
    height: 11.04rem;
    background: url('//cdn.yxvzb.com/html/shareToFans/pop.png') no-repeat;
    background-size: cover;
    margin: auto;
    margin-top: 2rem;
  }
}
</style>
